import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';
import type { AdminReservation } from '@/api/reservations/types';

import { toReservationRequestBody } from './reservation-payload';
import type { AdminReservationDraft } from './types';

export type AdminReservationErrorBody = {
  errors?: Record<string, string> | string[];
};

// Creates a Pending reservation (no payment intent). Throws the raw
// AxiosError so the form can render field-keyed 422 errors inline.
export const useCreateAdminReservation = createMutation<
  AdminReservation,
  AdminReservationDraft,
  AxiosError<AdminReservationErrorBody>
>({
  mutationFn: async (draft) =>
    client
      .post('v2/internal/partners/reservations', toReservationRequestBody(draft))
      .then((response) => response.data.data),
});
